import { AppDate } from '../envTypes';
import { ModelBase } from './base';

export enum GroupEventLocationType {
  InPerson = 'InPerson',
  GoogleMeet = 'GoogleMeet',
}

// //stores/{storeId}/groupEvent/{autoId}/
export interface GroupEvent extends ModelBase {
  listingId: string;
  name: string;
  description?: string;
  timezone: string;
  startDate: AppDate;
  endDate: AppDate;
  inviteeLimit: number;
  locationType: GroupEventLocationType;
  address?: string;
  totalBooked: number;
  calendarEvent?: {
    calendarId: string;
    eventId: string;
    meetingUrl?: string;
  };
}
